import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Contact.css'
import  { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {

    // email js 
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_so61zv4', 'template_21z73tu', form.current, 'PxEYjUsN33ryp99X4')
          .then((result) => {
              console.log(result.text);
              toast.success('send success')
          }, (error) => {
            toast.error('send Felid')
          });
        e.target.reset()
        }
    return (
        <div id='contact' className='bg-about mt-24 mb-16 pb-20'>
            <section className='lg:p-10 p-5 '>
                <div className='flex justify-start items-center'>
                    <h1  id='text' className=' font-bold text-white' >Contact</h1>
                    <div className='h-[2px] ml-4 lg:w-96  w-2/4 bg-green-600'></div>
                </div>
                    <h1  className='text-2xl font-bold text-white mt-10 uppercase'>Contact Me</h1>
                <section className='mt-10 grid lg:grid-cols-2 gap-5'>
                        <div data-aos="zoom-in-right" className='flex justify-start items-center bg-card p-5 mt-5'>
                            <i class="fa-solid fa-location-dot h-16 w-16 text-green-500 bg-card rounded-full  flex justify-center items-center text-3xl"></i>
                            <div className='font-bold text-white ml-5'>
                                <h1>My Address</h1>
                                <p>Dinajpur , Bangladesh</p>
                            </div>
                        </div>
                        <div data-aos="zoom-in-right" className='flex justify-start items-center bg-card p-5 mt-5'>
                            <i class="fa-solid fa-comment h-16 w-16 text-green-500 bg-card rounded-full  flex justify-center items-center text-3xl"></i>
                            <div className='font-bold text-white ml-5'>
                                <h1>Social Profiles</h1>
                                <p className='flex justify-start gap-5 mt-2 text-white'>
                                    <i class="fa-brands fa-square-facebook h-10 w-10 text-green-500 bg-about rounded-full  flex justify-center items-center"></i>
                                    <i class="fa-brands fa-linkedin h-10 w-10 text-green-500 bg-about rounded-full  flex justify-center items-center"></i>
                                    <i class="fa-brands fa-twitter h-10 w-10 text-green-500 bg-about rounded-full  flex justify-center items-center"></i>
                                </p>
                            </div>
                        </div>
                        <div data-aos="zoom-in-right" className='flex justify-start items-center bg-card p-5 mt-5'>
                            <i class="fa-solid fa-envelope h-16 w-16 text-green-500 bg-card rounded-full  flex justify-center items-center text-3xl"></i>
                            <div className='font-bold text-white ml-5'>
                                <h1>Email Me</h1>
                                <p className='flex justify-start gap-5 mt-2 text-green-500'>
                                    fl.shamim69@gmail.com
                                </p>
                            </div>
                        </div>
                        <div data-aos="zoom-in-right" className='flex justify-start items-center bg-card p-5 mt-5'>
                            <i class="fa-solid fa-phone h-16 w-16 text-green-500 bg-card rounded-full  flex justify-center items-center text-3xl"></i>
                            <div className='font-bold text-white ml-5'>
                                <h1>Call Me</h1>
                                <p className='flex justify-start gap-5 mt-2  text-green-500'>
                                01867585183
                                </p>
                            </div>
                        </div>
                </section>

                {/* email from  */}
                <form ref={form} onSubmit={sendEmail} className='mt-10'>
                    <div className='lg:flex gap-5'>
                        <input required name="from_name" data-aos="zoom-in-right" type="text" className='bg-card   text-green-500 border-0 w-full  mt-4' placeholder='Name'/>
                        <input required data-aos="zoom-in-right" type="email" name="_email" className='bg-card   text-green-500 border-0 w-full mt-4' placeholder='Email'/>
                    </div>
                    <input required data-aos="zoom-in-right" name='from_subject' type="text" className='bg-card   text-green-500 border-0 w-full mt-4'  placeholder='Subject'/>
                    <textarea required data-aos="zoom-in-right"  name="message" className='bg-card   text-green-500 border-0 w-full mt-4 p-5' id="" rows='5' placeholder='Message'></textarea>
                    <div className='flex justify-center w-full'>
                    <button type="submit" data-aos="fade-right" className='border-2  border-green-500 text-white font-bold px-5 mt-10 py-2 hover:bg-green-500 duration-500 rounded '>SEND</button>
                    </div>
                </form>
            </section>
            <ToastContainer />
        </div>
    );
};

export default Contact;


// service id  = service_so61zv4
// My Default Template
// Template ID:template_wrgyys5

// template_21z73tu